export default __webpack_public_path__ + "static/media/settings.b30e37f9.png";